import React, { ChangeEvent, FunctionComponent } from 'react'
import { useT } from '@transifex/react'
import { NoteError, NoteInput } from '../../shared/NoteInput'
import { isQuote } from '../../../functions/sale'
import { useAppDispatch, useAppSelector } from '../../../state/hooks'
import {
  selectHasUpdatedNoteOnConfirmation,
  selectIsSubmittedSaleEarly,
  selectSaleId,
  selectSaleNote,
  selectSaleStatus,
  setHasUpdateNoteOnConfirmation,
  setSaleNote,
} from '../../../state/slices/currentSale/currentSaleSlice'
import { useSaleManager } from '../../../ng-compat/hooks'

interface ConfirmationNoteProps {
  onErrorsChange?: (errors: NoteError[]) => void
}

const NOTE_CHAR_LIMIT = 2000

const PLACEHOLDER_CONTEXT = 'Placeholder for sale note input'

export const ConfirmationNote: FunctionComponent<ConfirmationNoteProps> = ({
  onErrorsChange,
}) => {
  const t = useT()
  const saleManager = useSaleManager()
  const dispatch = useAppDispatch()
  const status = useAppSelector(selectSaleStatus)
  const saleNote = useAppSelector(selectSaleNote)
  const saleId = useAppSelector(selectSaleId)
  const isSubmittedSaleEarly = useAppSelector(selectIsSubmittedSaleEarly)
  const noteUpdated = useAppSelector(selectHasUpdatedNoteOnConfirmation)

  const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const note = e.target.value
    dispatch(setSaleNote(note))
    if (!saleId && isSubmittedSaleEarly && !noteUpdated) {
      dispatch(setHasUpdateNoteOnConfirmation(true))
    }
    saleManager.saveSale()
  }

  const placeholder = isQuote(status)
    ? t('Type to add a quote note...', { _context: PLACEHOLDER_CONTEXT })
    : t('Type to add a sale note...', { _context: PLACEHOLDER_CONTEXT })
  return (
    <div className="sale-confirmation-form">
      <div className="sale-confirmation-form-row vd-flex--column sale-confirmation-form-row--space vd-mb1">
        <NoteInput
          note={saleNote}
          charLimit={NOTE_CHAR_LIMIT}
          placeholder={placeholder}
          onChange={onChange}
          onErrorsChange={onErrorsChange}
        />
      </div>
    </div>
  )
}
